/**
 * Hat-scoped label visibility for Review canvas + inspector.
 * Uses per-component hat when present; otherwise sheet-level extraction hat.
 */

export function componentHatId(component, sheetIr) {
  if (!component) return null;
  return component.discoveredByHat
    || component.hatId
    || sheetIr?.classification?.hatId
    || sheetIr?.mappingCheck?.hatId
    || null;
}

/**
 * Whether a component should paint under the active discipline hat lens.
 */
export function componentMatchesActiveHat(component, activeHatId, sheetIr) {
  if (!activeHatId || activeHatId === 'architect') return true;

  const explicit = component?.discoveredByHat || component?.hatId;
  if (explicit) return explicit === activeHatId;

  const sheetHat = sheetIr?.classification?.hatId || sheetIr?.mappingCheck?.hatId;
  if (sheetHat) return sheetHat === activeHatId;

  // No hat metadata on IR yet — show all labels (extracted under single-hat pipeline).
  return true;
}
